import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import { inlineDownloadUtils } from '../../hotel-center-utils';
import template from './template.pug';
import { PerformanceReportBase } from '../helper/performance-report-factory';

const i18n = globalContext.require('@bingads-webui/i18n-amd-loader!campaignui/feature/hotel-center');

export default class ShareOfVoiceReportView extends PerformanceReportBase {
  constructor({ p$daterange = null, perfMarker = null } = {}) {
    const reportColumns = [
      'HotelId',
      'HotelCountry',
      'HotelName',
      'PartnerHotelId',
      'Impressions',
      'EligibleImpressions',
      'MissedImpressions',
      'ImpressionShare',
      'MissedImpressionsSpendingCapReached',
      'MissedImpressionsInsufficientBid',
      'MissedImpressionsNoTax',
      'MissedImpressionsOther',
      'Clicks',
      'ClickShare',
      'CTR',
    ];
    const reportHeaders = [
      i18n.getString('HotelCenter_Overview_Grid_Hotel_ID_Label'),
      i18n.getString('HotelCenter_Overview_Grid_Country_Label'),
      i18n.getString('HotelCenter_Overview_Grid_SubAccount_Name_Label'),
      i18n.getString('HotelCenter_Overview_Grid_Hotel_Advertiser_Hotel_ID_Label'),
      i18n.getString('HotelCenter_Overview_Grid_Impression_Label'),
      i18n.getString('HotelCenter_Overview_Grid_SOV_Eligible_Impression_Label'),
      i18n.getString('HotelCenter_Overview_Grid_SOV_Missed_Impression_Label'),
      i18n.getString('HotelCenter_Overview_Grid_SOV_Impression_Share_Label'),
      i18n.getString('HotelCenter_Overview_Grid_SOV_Spending_Cap_Reached_Label'),
      i18n.getString('HotelCenter_Overview_Grid_SOV_Insufficient_Bid_Label'),
      i18n.getString('HotelCenter_Overview_Grid_SOV_No_Tax_Label'),
      i18n.getString('HotelCenter_Overview_Grid_SOV_Other_Label'),
      i18n.getString('HotelCenter_Overview_Grid_Clicks_Label'),
      i18n.getString('HotelCenter_Overview_Grid_SOV_Click_Share_Label'),
      i18n.getString('HotelCenter_Overview_Grid_CTR_Label'),
    ];


    const SOVPerfMarker = perfMarker ? perfMarker.createChild('HotelCenterSOVReport') : null;

    super({
      getTemplate: () => template,
      downloadButtonLocator: '.sov-report-download-button',
      reportColumns,
      reportHeaders,
      gridId: 'HotelSovReportDownloadGrid',
      processReportRule: inlineDownloadUtils.processReportRuleForHotelCenterBIDimensionRow,
      p$daterange,
      perfMarker: SOVPerfMarker,
    });
  }
}
